export default __webpack_public_path__ + "static/media/image-black.5039ac82.svg";